"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatMoneyCents = formatMoneyCents;
function formatMoneyCents(amount) {
  return "$" + (amount / 100).toFixed(2);
}